import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgInjuryFinger = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.625 8.87501L6.9775 4.52251C7.18146 4.31182 7.42531 4.14383 7.69484 4.02832C7.96437 3.91281 8.2542 3.85209 8.54743 3.84971C8.84066 3.84733 9.13144 3.90333 9.40281 4.01445C9.67418 4.12557 9.92073 4.28958 10.1281 4.49693C10.3354 4.70429 10.4994 4.95083 10.6106 5.2222C10.7217 5.49358 10.7777 5.78435 10.7753 6.07758C10.7729 6.37081 10.7122 6.66064 10.5967 6.93017C10.4812 7.1997 10.3132 7.44355 10.1025 7.64751L8.875 8.87501H18.875C19.538 8.87501 20.1739 9.1384 20.6428 9.60724C21.1116 10.0761 21.375 10.712 21.375 11.375C21.375 12.0381 21.1116 12.6739 20.6428 13.1428C20.1739 13.6116 19.538 13.875 18.875 13.875H12.625V15.125C12.625 16.4511 12.0982 17.7229 11.1605 18.6605C10.2229 19.5982 8.95108 20.125 7.625 20.125H2.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.375 13.875V8.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.625 13.875V8.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgInjuryFinger.displayName = 'SvgInjuryFinger';
export default SvgInjuryFinger;
